import React, { FC } from 'react'

import './ProjectsTableHeader.scss'
import { ENABLED_FEATURES } from 'shared/utils/featureFlags'

const ProjectsTableHeader: FC<{ isSpace: boolean }> = ({ isSpace }) => {
  const nameColumnSpan = isSpace ? 4 : 7
  const unitColumnSpan = isSpace ? 3 : 4

  return (
    <div className="sbx-row sbx-row-gutter-10 project-table-header">
      <div className="sbx-col-1 project-table-header__first-col"></div>
      <div className={`sbx-col-sm-${nameColumnSpan} sbx-col-md-${nameColumnSpan} sbx-col-lg-${nameColumnSpan}`}>
        <div className="project-table-header__artist">Artist/Project</div>
      </div>
      <div className="sbx-col-3">
        <div className="project-table-header__products">#Products</div>
      </div>
      {isSpace ? <div className="sbx-col-2">Zone</div> : null}

      <div className={`sbx-col-${unitColumnSpan}`}>
        <div className="project-table-header__unit">Local Unit</div>
      </div>
      <div className="sbx-col-2">
        <div className="project-table-header__date">Date</div>
      </div>
      <div className="sbx-col-3">
        <div className="project-table-header__owner">Project Owner</div>
      </div>
      {ENABLED_FEATURES.GLOBALHUB && (
        <div className="sbx-col-2">Globalized</div>
      )}
      <div className="sbx-col-2">
        <div className="project-table-header__follow">Follow Status</div>
      </div>
    </div>
  )
}

export default ProjectsTableHeader
